export default __webpack_public_path__ + "static/media/avatar.685a9214.png";